import { NgModule } from '@angular/core';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { BannerPanelComponent } from './components/banner-panel.component';

@NgModule({
  imports: [LazyLoadImageModule],
  exports: [BannerPanelComponent],
  declarations: [BannerPanelComponent],
  providers: [],
})
export class AccredibleBannerPanelModule {}
